import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CssBaseline,
  Fab,
  TextField,
  Button,
  Dialog, 
  DialogTitle,
  DialogContent,
  DialogActions,
  Card, 
  CardContent,
  CardActions,
} from '@mui/material';
import { Container } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFiles, addFile, removeFile } from '../../redux/actions/filesActions';
import AddIcon from '@mui/icons-material/Add';
import { uploadPDFFile } from '../../services/firebaseStorage';
import { useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom'; 

function FilesTabContent() {
  const dispatch = useDispatch();
  const files = useSelector((state) => state.files.data);
  const loading = useSelector((state) => state.files.loading);
  const [isDialogOpen, setIsDialogOpen] = useState(false); 
  const [pdf, setPdf] = useState(null); 

  const [newFile, setNewFile] = useState({
    label: '',
    value: '',
    path : null,
  });

  useEffect(() => {
    dispatch(fetchFiles());
  }, [dispatch]);


  const handleAddFile = async () => {
    try {
      if (pdf) {
        const downloadURL = await uploadPDFFile(pdf);
        setNewFile({
          ...newFile,
          path: downloadURL,
        });
        dispatch(addFile({ label: newFile.label,
        value: newFile.value,
        path : downloadURL,})).then(() => {
          setIsDialogOpen(false);
          dispatch(fetchFiles());
        });
      } else {
      }
    } catch (error) {
    }
  };

  const handleRemoveFile = (fileId) => {
    dispatch(removeFile(fileId)).then(() => {
      dispatch(fetchFiles());
    });
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <CssBaseline />
      <Fab
        color="primary"
        aria-label="add"
        style={{ position: 'fixed', bottom: '16px', right: '16px', backgroundColor: '#FC6258' }}
        onClick={() => setIsDialogOpen(true)}
      >
        <AddIcon style={{ color: 'white' }} />
      </Fab>

      {isMobile ? (
        <Container>
          {files.map((file, index) => (
            <Card key={index} variant="outlined" style={{ margin: '16px' }}>
              <CardContent>
                <h3>{file.label}</h3>
                <p>{file.value}</p>
                <Link to={file.path}>Lien</Link>
              </CardContent>
              <CardActions>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleRemoveFile(file.id)}
                >
                  Supprimer
                </Button>
              </CardActions>
            </Card>
          ))}
        </Container>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Titre</TableCell>
                <TableCell>Déscription</TableCell>
                <TableCell>Lien</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {files.map((file, index) => (
                <TableRow key={index}>
                  <TableCell>{file.label}</TableCell>
                  <TableCell>{file.value}</TableCell>
                  <TableCell>
                    <Link to={file.path}>Lien</Link>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleRemoveFile(file.id)}
                    >
                      Supprimer
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}


<Dialog
        open={isDialogOpen} 
        onClose={() => setIsDialogOpen(false)} 
        aria-labelledby="add-file-dialog"
      >
        <DialogTitle id="add-file-dialog">Ajouter un nouveau fichier</DialogTitle>
        <DialogContent>
          <TextField
            label="Titre"
            variant="outlined"
            fullWidth
            margin="normal"
            value={newFile.label}
            onChange={(e) => setNewFile({ ...newFile, label: e.target.value })}
          />
          <TextField
            label="Déscription"
            variant="outlined"
            fullWidth
            margin="normal"
            value={newFile.value}
            onChange={(e) => setNewFile({ ...newFile, value: e.target.value })}
          />
          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt"
            placeholder="Sélectionnez une fichier"
            aria-label="Aucun fichier sélectionné"
            onChange={(e) => setPdf(e.target.files[0])}
          />
        </DialogContent>
        <DialogActions>
        <Button
  variant="outlined"
  onClick={() => setIsDialogOpen(false)}
  style={{ color: '#FC6258', borderColor: '#FC6258' }}
>
  Annuler
</Button>
<Button
  variant="contained"
  color="primary"
  onClick={handleAddFile}
  style={{ backgroundColor: '#FC6258', color: 'white' }}
>
  Ajouter le fichier
</Button>

        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FilesTabContent;


